module.exports = __webpack_public_path__ + "assets/assets/images/home/our-mission.94e01370.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/home/our-mission.svg
// module id = 213
// module chunks = 0